import axios from 'axios';
import { serverConfig } from './server-config';

let getDomainFromAddressBar = () => {
  // Get the current URL from the address bar
  const currentURL = window.location.href;

  // Create a URL object from the URL string
  const url = new URL(currentURL);

  // Extract and return the domain (host) from the URL
  return url.hostname;
};

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Auth token has expired or is invalid, delete it from local storage
      localStorage.removeItem('authToken');
      if (window.location.pathname !== '/login') {
        location.reload();
      }
    }
    return Promise.reject(error);
  }
);
export const CandidatePostLoginService = {
  uploadCandidateFile: (formData, fileType, onSuccess, setLoader) => {
    setLoader && setLoader(true);
    axios
      .post(`https://${serverConfig.serverBaseAddress}/signite/candidate/post-login/upload/file?docType=${fileType}`, formData, {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response1) => {
        setLoader && setLoader(false);
        onSuccess(response1.data);

      })
      .catch((error) => {
        console.error(error);
        setLoader && setLoader(false);
      });
  },
  deleteCandidateFile: (filePath, fileType, onSuccess, setLoader) => {
    setLoader && setLoader(true);
    return axios
      .delete(
        `https://${serverConfig.serverBaseAddress}/signite/candidate/post-login/delete/file?docType=${fileType}&path=${encodeURIComponent(filePath)}`,
        {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('authToken'),
          },
        }
      )
      .then((response) => {
        setLoader && setLoader(false);
        onSuccess && onSuccess(response.data);
      })
      .catch((error) => {
        setLoader && setLoader(false);
        throw error;
      });
  },




  submitForApproval: async () => {
    return axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/candidate/post-login/submit-for-approval`,
      {},
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },
  candidateSubmit: async (candidateData, section) => {
    return axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/candidate/post-login/submit?section=` + section,
      candidateData,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },

  submitPanelByType: async (panelType, data) => {
    return axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/candidate/post-login/submit/${panelType}`,
      data,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },

  candidateTopLeftEdit: async (data) => {
    return axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/candidate/post-login/submit/top-left-panel`,
      data,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },


  submitTechProficiencies: async (data) => {
    return axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/candidate/post-login/submit/tech-proficiencies`,
      data,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },

  submitCertifications: async (data) => {

    return axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/candidate/post-login/submit/certifications`,
      data,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },
  candidateValueAddRightPanel: async (data) => {
    return axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/candidate/post-login/submit/right-panel-section-2`,
      data,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },

  submitAwards: async (awardsArray) => {
    const payload = awardsArray.map(award => {
      const base = {
        title: award.title,
        providedBy: award.providedBy,
        issueYear: award.issueYear,
      };

      if (Array.isArray(award.awardDoc) && award.awardDoc.length > 0) {
        base.awardDoc = award.awardDoc.map(doc => ({
          originalName: doc.originalName,
          path: doc.path,
          fileSize: doc.fileSize,
          fileSizeUnit: doc.fileSizeUnit,
        }));
      }

      return base;
    });

    return axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/candidate/post-login/submit/awards`,
      payload,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
          'Content-Type': 'application/json',
        },
      }
    );
  },

  submitFamilyDetails: async (data) => {
    return axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/candidate/post-login/submit/family-details`,
      data,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },

  submitLanguageProficiency: async (data) => {
    return axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/candidate/post-login/submit/language-proficiency`,
      data,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },

  submitInterests: async (data) => {
    return axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/candidate/post-login/submit/interests`,
      data,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },
  submitFeedback: async (payload) => {
    return axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/candidate/post-login/submit-feedback`,
      payload,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },
  submitProfessionalMemberships: async (data) => {
    return axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/candidate/post-login/submit/professional-memberships`,
      data,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },

  submitTotalExpCompensation: async (data) => {
    return axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/candidate/post-login/submit/total-exp-compensation`,
      data,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },

  submitProfessionalRefs: async (data) => {
    return axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/candidate/post-login/submit/professional-refs`,
      data,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },

  getAssesmentMasterData: async (data) => {
    return axios.get(
      `https://${serverConfig.serverBaseAddress}/signite/data/assessment-details`,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },
  purchaseAssesment: async (assessmentId) => {
    return axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/assessment/purchase`,
      {
        "productId": assessmentId,
        "productType": "ASSESSMENT",
        "gateway": "RAZORPAY"
      },
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },

  getPurchasedAssesmentList: async (page = 0, size = 100) => {
    return axios.get(
      `https://${serverConfig.serverBaseAddress}/signite/assessment/purchase/list?page=${page}&size=${size}`,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },
  getAvailableAssessmentList: async () => {
    return axios.get(
      `https://${serverConfig.serverBaseAddress}/signite/assessment/get/available`,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },
  getOngoingAssessmentList: async () => {
    return axios.get(
      `https://${serverConfig.serverBaseAddress}/signite/assessment/get/started`,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },
  startAssessment: async (assessmentId) => {
    return axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/assessment/start/${assessmentId}`,
      null,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },

  getCompletedAssessmentList: async () => {
    return axios.get(
      `https://${serverConfig.serverBaseAddress}/signite/assessment/get/completed`,
      {
        headers: {
          Authorization: `Bearer ` + localStorage.getItem('authToken'),
        },
      }
    );
  },

  /*
   transactionId: response.data.transactionId,
                                razorpay_payment_id: paymentResponse.razorpay_payment_id,
                                razorpay_order_id: paymentResponse.razorpay_order_id,
                                razorpay_signature: paymentResponse.razorpay_signature,*/

  verifyPayment: async (verificationData) => {
    return axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/razorpay/verify-payment`,
      verificationData,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },
}
